module.exports = "images/location_parking.8e5fc75ff9534a7314ae1a23fbf650d2.png";